<template>
  <div
    :class="alertClasses"
  >
    <div class="variation-alert__icon">
      <DsIcon :name="iconName" size="small" />
    </div>
    <div class="variation-alert__content">
      <div
        v-if="Boolean(title)"
        class="variation-alert__content-title"
      >
        {{ title }}
      </div>
      <div class="variation-alert__content-body">
        <slot></slot>
      </div>
    </div>
    <div
      v-if="!hideClose"
      class="variation-alert__close"
      @click="$emit('close')"
    >
      <DsIcon
        name="close"
        size="small"
      />
    </div>
  </div>
</template>

<script>
import { DsIcon } from '@ds/icons';

export default {
  name: 'DsAlert',
  components: {
    DsIcon,
  },
  data() {
    return {
      iconByType: {
        warning: 'warning',
        error: 'error',
        info: 'info',
      },
    };
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'error',
    },
    dsIcon: {
      type: String,
      default: '',
    },
  },
  computed: {
    alertType() {
      const allowedTypes = Object.keys(this.iconByType);

      return allowedTypes.includes(this.type)
        ? this.type
        : allowedTypes[0];
    },
    iconName() {
      const dsIconName = this.iconByType[this.alertType]
      return this.dsIcon || dsIconName;
    },
    alertClasses() {
      return [
        'variation-alert',
        `variation-alert--${this.alertType}`,
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@ds/styles/Colors.scss';
@import '~@ds/styles/Alert.scss';
</style>
